import React, { useEffect, useState, Fragment, createElement } from 'react';
import { Link } from 'react-router-dom';
import { GlobeIcon } from 'lucide-react';
declare global {
  interface Window {
    google: any;
    googleTranslateElementInit: () => void;
  }
}
type LangCode = 'en' | 'fr' | 'es' | 'ar' | 'pt';
const LANGUAGES: {
  code: LangCode;
  label: string;
  aria: string;
}[] = [{
  code: 'en',
  label: 'EN',
  aria: 'Switch to English'
}, {
  code: 'fr',
  label: 'FR',
  aria: 'Changer en français'
}, {
  code: 'es',
  label: 'ES',
  aria: 'Cambiar a español'
}, {
  code: 'ar',
  label: 'AR',
  aria: 'التبديل إلى العربية'
}, {
  code: 'pt',
  label: 'PT',
  aria: 'Mudar para português'
}];
export function TopBar() {
  const [currentLang, setCurrentLang] = useState<LangCode>('en');
  useEffect(() => {
    const existingScript = document.getElementById('google-translate-script');
    if (existingScript) return;
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: 'en,fr,es,ar,pt',
          autoDisplay: false
        }, 'google_translate_element');
      }
    };
    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const setLanguage = (lang: LangCode) => {
    setCurrentLang(lang);
    // Set document direction for Arabic (RTL)
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    const triggerChange = () => {
      const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (select) {
        select.value = lang;
        select.dispatchEvent(new Event('change'));
        return true;
      }
      return false;
    };
    if (!triggerChange()) {
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (triggerChange() || attempts > 20) {
          clearInterval(interval);
        }
      }, 200);
    }
  };
  return <div className="bg-charcoal text-white text-sm" data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center gap-4" data-id="element-286">
        <Link to="/about-au" className="text-xs hover:text-au-gold transition-colors font-medium whitespace-nowrap" data-id="element-287">
          About the African Union
        </Link>
        <div className="flex items-center gap-4" data-id="element-288">
          <div className="flex items-center gap-1" data-id="element-289">
            <GlobeIcon size={16} className="flex-shrink-0" data-id="element-290" />
            {LANGUAGES.map((lang, idx) => <Fragment key={lang.code} data-id="element-291">
                {idx > 0 && <span className="text-gray-500" data-id="element-292">|</span>}
                <button onClick={() => setLanguage(lang.code)} className={`px-2 py-0.5 rounded transition-colors text-xs ${currentLang === lang.code ? 'bg-au-gold text-charcoal font-semibold' : 'hover:text-au-gold'}`} aria-label={lang.aria} data-id="element-293">
                  {lang.label}
                </button>
              </Fragment>)}
          </div>
        </div>
        {/* Hidden Google Translate widget mount point */}
        <div id="google_translate_element" style={{
        display: 'none'
      }} data-id="element-294"></div>
      </div>
    </div>;
}